import React, {Component} from 'react'
import Preferences from '../api/services/Preferences';
import ClinicService from '../api/services/ClinicService';
import AccountService from '../api/services/AccountService';


import AppPrintView from "./print/AppPrintView";
import {DocumentList} from "./Clients/UserDetails";

const prefApi = new Preferences();
const account = new AccountService();
export default class dev extends Component {

	test = () => {
		console.log("Dr List PRefs:", this.getDrListPref())
	}

	getDrListPref() {
		const savedList = Preferences.GetClinicPref('dayViewColItems');
		const dl = ClinicService.GetDoctors(account.clinicId, true);
		console.log('Saved List:', savedList)
		if (savedList) {

			const allListIndex = {};
			dl.map((dr) => {
				allListIndex[dr.userId] = dr;
			})

			console.log('alluser index:', allListIndex)

			return savedList.map((d) => {
				return allListIndex[d.userId || d];
			})
		}
		return dl;
	}


	render() {
		//console.log("Dr List PRefs:", this.getDrListPref())

		return <DocumentList />


		/*return (
			<div>
				<button onClick={this.test}>Test</button>
			</div>
		)*/
	}
}



// WEBPACK FOOTER //
// ./src/views/dev.jsx